import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import StudentForm from "@/components/StudentForm";
import { ArrowLeft, UserPlus } from "lucide-react";
import { toast } from "sonner";

export default function StudentNew() {
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const submit = async (payload) => {
    setSaving(true);
    try {
      const { data } = await api.post("/students", payload);
      toast.success(`${data.name} enrolled · ${data.student_id}`);
      navigate(`/students/${data.id}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to create student");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6 md:p-10 max-w-4xl mx-auto" data-testid="add-student-page">
      <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 mb-6">
        <ArrowLeft size={16} /> Back
      </button>
      <div className="mb-8">
        <div className="label-caps mb-2 flex items-center gap-2"><UserPlus size={12} /> New Admission</div>
        <h1 className="text-4xl font-bold tracking-tight" style={{ fontFamily: "Chivo" }}>Add Student</h1>
        <p className="text-slate-500 mt-1">Fill admission details. Fee structure can be set up after creation.</p>
      </div>
      <StudentForm onSubmit={submit} submitLabel="Create Admission" saving={saving} />
    </div>
  );
}
